import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  gap: 35px;
  margin-top: 15px;
`;

export const AdsListContainer = styled.div<{ $isVipPage?: boolean }>`
  width: 100%;
  margin-bottom: ${({ $isVipPage }) => ($isVipPage ? 40 : 30)}px;
`;

export const AdsListToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const NoResultsInCategoryText = styled.p`
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 15px;
  line-height: 24px;
  margin: 0;
  padding: 25px 0 0;

  strong {
    font-weight: 700;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 25px 15px 0;
  }
`;
